import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { GooglePlacesService } from '../../../domain/service/GooglePlaceService';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';

@Component({
  selector: 'app-owner-form',
  templateUrl: './owner-form.component.html',
  styleUrl: './owner-form.component.css'
})
export class OwnerFormComponent implements OnInit{
  @Input() ownerForm!: FormGroup
  addressType:string = '1';
  suggestions: any[] = [];
  @Input() states: DropDownModel[] = [];
  @Input() countries: DropDownModel[] = [];
  constructor(private googlePlacesService: GooglePlacesService){
 
  }
  ngOnInit(): void {
   

    this.ownerForm.get('ownerStreetAddress')?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
        });
      } else {
        this.suggestions = [];
      }
    });
  }
  radioChangeAddress(event: any) {
    this.addressType = event.value;
    if(event.value == "1"){
      this.ownerForm.get('addressName')?.clearValidators();
      this.ownerForm.get('addressName')?.updateValueAndValidity();
  
      this.ownerForm.get('addressOrPoBox')?.clearValidators();
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();
  
      this.ownerForm.get('cityStateProvince')?.clearValidators();
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();
  
      this.ownerForm.get('country')?.clearValidators();
      this.ownerForm.get('country')?.updateValueAndValidity();
  
      this.ownerForm.get('ownerStreetAddress')?.addValidators(Validators.required);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
  
      this.ownerForm.get('aptUnitSuite')?.addValidators(Validators.required);
      this.ownerForm.get('aptUnitSuite')?.updateValueAndValidity();
  
      this.ownerForm.get('city')?.addValidators(Validators.required);
      this.ownerForm.get('city')?.updateValueAndValidity();
  
      this.ownerForm.get('state')?.addValidators(Validators.required);
      this.ownerForm.get('state')?.updateValueAndValidity();
  
      this.ownerForm.get('zipCode')?.addValidators( Validators.required);
      this.ownerForm.get('zipCode')?.addValidators(Validators.maxLength(12));
      this.ownerForm.get('zipCode')?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.ownerForm.get('zipCode')?.updateValueAndValidity();
  
    }
    if(event.value == "2"){
  
      this.ownerForm.get('addressName')?.addValidators(Validators.required);
      this.ownerForm.get('addressName')?.updateValueAndValidity();
  
      this.ownerForm.get('addressOrPoBox')?.addValidators(Validators.required);
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();
  
      this.ownerForm.get('cityStateProvince')?.addValidators(Validators.required);
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();
  
      this.ownerForm.get('country')?.addValidators(Validators.required);
      this.ownerForm.get('country')?.updateValueAndValidity();
  
   
      this.ownerForm.get('ownerStreetAddress')?.clearValidators();
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
  
      this.ownerForm.get('aptUnitSuite')?.clearValidators();
      this.ownerForm.get('aptUnitSuite')?.updateValueAndValidity();
  
      this.ownerForm.get('city')?.clearValidators();
      this.ownerForm.get('city')?.updateValueAndValidity();
  
      this.ownerForm.get('state')?.clearValidators();
      this.ownerForm.get('state')?.updateValueAndValidity();
  
      this.ownerForm.get('zipCode')?.clearValidators();
      this.ownerForm.get('zipCode')?.updateValueAndValidity();
    }
  
    
  }  
  async selectPlaceOwner(place: any) {
 
    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);
  
    if (selectedZipCode.zip){
      this.ownerForm.get('zipCode')?.setValue(selectedZipCode.zip);
    }
  
    if (selectedZipCode.city){
      this.ownerForm.get('city')?.setValue(selectedZipCode.city);
    }
  
    if (selectedZipCode.stateCode){
      let stateId = this.states.find(e => e.iso2 ==selectedZipCode.stateCode )?.id ?? 0;
 
      this.ownerForm.get('state')?.setValue(stateId);
    }
    if (selectedZipCode.address){
      this.ownerForm.get('ownerStreetAddress')?.setValue(selectedZipCode.address);
    this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
    this.ownerForm.get('ownerStreetAddress')?.markAsUntouched();
    }
  }
}
